"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function Video() {
    return (react_1.default.createElement("svg", { width: "56", height: "56", viewBox: "0 0 56 56" },
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "#BFBFBF", strokeWidth: "2", transform: "translate(4 9)" },
            react_1.default.createElement("rect", { width: "50", height: "40", x: "-1", y: "-1", fill: "#F5F5F5" }),
            react_1.default.createElement("path", { fill: "#FFF", d: "M25,13.8179682 L31.4256297,24.8333333 L18.5743703,24.8333333 L25,13.8179682 Z", transform: "rotate(90 25 18.833)" }))));
}
exports.default = Video;
//# sourceMappingURL=Video.js.map